"use client";
import { decode } from "html-entities";
import ImageWithFallback from "./image-with-fallback";
import { ICategoryHomepageData } from "@/types/general";
import useLocalizedRouter from "@/hooks/use-localized-router";

interface ItemProps {
  item: ICategoryHomepageData;
}

const CategoryItem = ({ item }: ItemProps) => {
  const router = useLocalizedRouter();

  return (
    <button
      data-testid={`category-${item.seo_link}-link`}
      onClick={() => router.push(`category/${item.seo_link}`)}
      className="ease my-1 mr-[15px] flex h-[50px] items-center justify-between gap-[15px] rounded-[8px] border border-[#dfdfe0] bg-[#eeeeef80] px-2 text-black transition duration-300 hover:bg-[#eeeeef80] hover:text-primary hover:shadow-none"
    >
      <p className="text-sm">{decode(item.title)}</p>
      <ImageWithFallback src={item.image} alt="" width={30} height={30} />
    </button>
  );
};

export default CategoryItem;
